import { useState } from 'react'
import axiosInstance from '@/lib/axios'
import { API_ENDPOINTS } from '@/config/api'

export interface LibrettoPneumatico {
  misura_completa: string | null
  larghezza_mm: number | null
  spalla_pct: number | null
  struttura: string | null
  diametro_in: number | null
  indice_carico: string | null
  codice_velocita: string | null
  stagione: 'estivo' | 'invernale' | '4stagioni' | null
}

export interface LibrettoData {
  targa?: string | null
  telaio?: string | null
  marca?: string | null
  modello?: string | null
  prima_immatricolazione?: string | null
  data_immatricolazione_attuale?: string | null
  carburante?: string | null
  cilindrata_cc?: number | null
  kw?: number | null
  cv?: number | null
  porte?: number | null
  posti?: number | null
  categoria_veicolo?: string | null
  carrozzeria?: string | null
  emissioni_co2_gkm?: number | null
  classe_emissioni?: string | null
  massa_max_kg?: number | null
  intestatario_cognome?: string | null
  intestatario_nome?: string | null
  intestatario_indirizzo?: string | null
  intestatario_compr_cognome?: string | null
  intestatario_compr_nome?: string | null
  intestatario_compr_indirizzo?: string | null
  proprietario_cognome?: string | null
  proprietario_nome?: string | null
  proprietario_indirizzo?: string | null
  proprietario_compr_cognome?: string | null
  proprietario_compr_nome?: string | null
  proprietario_compr_indirizzo?: string | null
  utilizzatore_cognome?: string | null
  utilizzatore_nome?: string | null
  utilizzatore_indirizzo?: string | null
  utilizzatore_compr_cognome?: string | null
  utilizzatore_compr_nome?: string | null
  utilizzatore_compr_indirizzo?: string | null
  pneumatici?: LibrettoPneumatico[]
  avvertenza?: string
}

export const useLibrettoOcr = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const analizza = async (file: File): Promise<LibrettoData> => {
    setIsLoading(true)
    setError(null)
    try {
      const formData = new FormData()
      formData.append('file', file)
      const response = await axiosInstance.post<LibrettoData>(
        API_ENDPOINTS.AUTO_ANALIZZA_LIBRETTO,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )
      return response.data
    } catch (err: any) {
      const msg =
        err?.response?.data?.detail ||
        'Analisi non disponibile. Inserisci i dati manualmente.'
      setError(msg)
      throw err
    } finally {
      setIsLoading(false)
    }
  }

  return { analizza, isLoading, error }
}
